<div class="w-full lg:max-w-full lg:flex login-page">
  <div
    class="bg-cover bg-center bg-no-repeat lg:border-l-0 lg:border-t lg:border-gray-400 bg-white rounded-b lg:rounded-b-none lg:rounded-r pt-6 w-full card-form"
    style="
      background-image: url(&quot;assets/img/Background formulaire candidature Force-N.jpeg&quot;);
      background-size: cover;
      background-position: center;
      background-attachment: fixed;
    ">
    <div class="w-4/5 grid-cols-1 flex place-content-center mr-auto ml-auto">
      <app-card-form style="opacity: 0.8">
        <div class="flex justify-between mb-10">
          <div class="logo-icon" style="background-image: url(&quot;assets/img/logo_unchk.png&quot;)"></div>
          <div class="logo-icon" style="
              background-image: url(&quot;assets/img/logo_master_card.png&quot;);
            "></div>
        </div>
        <div class="flex justify-center items-center">
          <!--Classic -->
          <div class="text-center">
            <span class="font-bold text-2xl">FORMULAIRE D’ENRÔLEMENT DES PARTENAIRES
            </span>
            <br />
            Pour le dispositif d'accompagnement des fonds d'amorçage du
            Programme Force-N
          </div>
        </div>
        <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
        <div class="flex justify-center mb-10">
          <img src="assets/img/FN-LOGO.png" alt="logo" class="w-14 h-auto" />
        </div>
        <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <div class="text-justify">
            Veuillez fournir des informations exactes. Toute information erronée
            pourrait entraîner des perturbations lors de votre connexion à notre
            plateforme. Après la soumission, les notifications, les comptes
            d’accès aux plateformes et divers autres documents seront générés à
            partir des informations ci-dessous.
          </div>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
          <form [formGroup]="soumissionForm">
            <div class="flex justify-center items-center" *ngIf="isError" style="color: #ff0000">
              Une erreur s'est produite, veuillez reessayer!
            </div>

            <!---INFOS PERSON-->
            <div class="flex justify-between gap-2 gap-6 my-6">
              <span class="font-bold text-2xl">I. INFORMATIONS PERSONNELLES</span>
            </div>
            <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

            <div class="grid lg:grid-cols-3 lg:gap-6 m-0">
              <div class="relative z-0 w-full group">
                <div class="col-span-1 label">
                  <div class="lg:flex lg:me-3">
                    Prénom - Nom
                    <span style="color: red">*</span>
                  </div>
                  <div *ngIf="
                      isFieldInvalid('firstname') || isFieldInvalid('lastname')
                    " style="color: #eb1c1c">
                    Champ requis
                  </div>
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <input type="text" id="prenom"
                  class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                  formControlName="firstname" [style.border]="
                    isFieldInvalid('firstname') ? '2px solid #eb1c1c' : ''
                  " />
                <div class="mt-1 text-sm">
                  <p>Prénom</p>
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <input type="text" id="nom"
                  class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                  formControlName="lastname" [style.border]="
                    isFieldInvalid('lastname') ? '2px solid #eb1c1c' : ''
                  " />
                <div class="mt-1 text-sm">
                  <p>Nom</p>
                </div>
              </div>
            </div>
            <div class="relative">
              <div class="grid lg:grid-cols-3 lg:gap-6 my-6 m-0">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Date de naissance
                      <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('dateBirth')" style="color: #eb1c1c">
                      Champ requis
                    </div>
                    <!-- <div *ngIf="checkValidAge()" style="color: #eb1c1c">
                      L'âge limite de candidature est de 35 ans
                    </div> -->
                  </div>
                </div>
                <div class="col-span-2">
                  <div class="flex justify-between gap-3">
                    <div class="w-full">
                      <input type="date" formControlName="dateBirth" id="year"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        [style.border]="
                          isFieldInvalid('dateBirth') ? '2px solid #eb1c1c' : ''
                        " />

                      <div class="mt-1">
                        <p class="text-sm">
                          Saisir votre date de naissance ou vous pouvez
                          directement selectionner la date dans l'agenda.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="grid md:grid-cols-3 md:gap-6 mx-0 my-4">
              <div class="relative z-0 w-full mb-0 md:mb-2 group pt-0 md:pt-3">
                <div class="col-span-1 label">
                  <div class="lg:flex lg:me-3">
                    Sexe
                    <span style="color: red">*</span>
                  </div>
                  <div *ngIf="isFieldInvalid('gender')" style="color: #eb1c1c">
                    Champ requis
                  </div>
                </div>
              </div>
              <div class="relative z-0 w-full mb-0 md:mb-2 group">
                <div class="flex items-center">
                  <input formControlName="gender" id="bordered-radio" type="radio" [value]="1" name="gender"
                    class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    [style.border]="
                      isFieldInvalid('gender') ? '2px solid #eb1c1c' : ''
                    " />
                  <label for="bordered-radio"
                    class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Masculin</label>
                </div>
              </div>
              <div class="relative z-0 w-full mb-0 md:mb-2 group">
                <div class="flex items-center">
                  <input formControlName="gender" id="bordered-radio" [value]="2" type="radio" name="gender"
                    class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    [style.border]="
                      isFieldInvalid('gender') ? '2px solid #eb1c1c' : ''
                    " />
                  <label for="bordered-radio"
                    class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Féminin</label>
                </div>
              </div>
            </div>
            <div class="grid lg:grid-cols-3 lg:gap-6 m-0">
              <div class="relative z-0 w-full group">
                <div class="col-span-1 label">
                  <div class="lg:flex lg:me-3">
                    Numéro de téléphone
                    <span style="color: red">*</span>
                  </div>
                  <div *ngIf="
                      isFieldInvalid('phoneNumberOne') ||
                      isFieldInvalid('phoneCode')
                    " style="color: #eb1c1c">
                    Champ requis
                  </div>
                  <!-- <div *ngIf="checkValideCallNumber()" style="color: #eb1c1c">
                    Tapez seulement des nombres!
                  </div> -->
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <select type="text" id="prenom"
                  class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                  formControlName="phoneCode" [style.border]="
                    isFieldInvalid('phoneCode') ? '2px solid #eb1c1c' : ''
                  ">
                  <option *ngFor="let phonecode of phoneCode" [value]="phonecode.phoneCode">
                    {{ phonecode.phoneCode }}
                  </option>
                </select>
                <div class="mt-1 text-sm">
                  <p>Indicatif pays</p>
                </div>
              </div>
              <div class="relative z-0 w-full group">
                <div>
                  <input type="tel" id="phoneNumberOne"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    formControlName="phoneNumberOne" onlyNumber [style.border]="
                      isFieldInvalid('phoneNumberOne')
                        ? '2px solid #eb1c1c'
                        : ''
                    " />
                  <div class="mt-1 text-sm">
                    <p>Numéro de téléphone</p>
                  </div>
                </div>
                <div class="mt-2">
                  <input type="tel" id="phoneNumberTwo"
                    class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6 bg-white"
                    formControlName="phoneNumberTwo" />
                  <div class="mt-1 text-sm">
                    <p>Numéro de téléphone 2</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Formulaire précédemment fourni -->
            <!--*ngIf="pageOne"-->
            <div>
              <div formGroupName="emailGroup">
                <div class="grid md:grid-cols-3 md:gap-6 mt-5 md:mb-2 m-0">
                  <div class="relative z-0 w-full group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3">
                        Adresse email
                        <span style="color: #ff0000">*</span>
                      </div>

                      <div *ngIf="isFieldInvalidForMails('emailGroup.email')" style="color: #eb1c1c">
                        Champ requis
                      </div>
                      <div *ngIf="isMailFieldInvalid('email')" style="color: #eb1c1c">
                        Format de l'email invalide.
                      </div>
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full group">
                      <input type="text" id="email"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        placeholder="Par ex : monnom@exemple.com" formControlName="email" [style.border]="
                          isFieldInvalid('emailGroup.email')
                            ? '2px solid #eb1c1c'
                            : ''
                        " />
                    </div>
                  </div>
                </div>
                <div class="grid md:grid-cols-3 md:gap-6 m-0 md:mt-4">
                  <div class="relative z-0 w-full mb-5 group">
                    <div class="col-span-1 label">
                      <div class="lg:flex lg:me-3"></div>
                    </div>

                    <div *ngIf="isFieldInvalidForMails('emailGroup.confirmEmail')" style="color: #eb1c1c">
                      Champ requis
                    </div>
                    <div *ngIf="isMailFieldInvalid('confirmEmail')" style="color: #eb1c1c">
                      Format de l'email invalide.
                    </div>

                    <div *ngIf="showEmailErrors$ | async" style="color: #eb1c1c">
                      Mettez des mails identiques
                    </div>
                  </div>
                  <div class="col-span-2 label">
                    <div class="relative z-0 w-full mb-5 group">
                      <input type="email" id="confirmEmail"
                        class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                        formControlName="confirmEmail" placeholder="Veuillez confirmer votre adresse email"
                        [style.border]="
                          isFieldInvalid('emailGroup.confirmEmail')
                            ? '2px solid #eb1c1c'
                            : ''
                        " />
                      <div class="mt-1 text-sm">
                        <p>
                          Pour être sûr de bien recevoir nos mails, merci
                          d'utiliser des adresses type Gmail, Evitez les
                          adresses Outlook, Yahoo, Hotmail et professionnelles.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 md:gap-6 mb-6 m-0">
                <div class="relative z-0 w-full mb-0 md:mb-5 group pt-4">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Nationalité
                      <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('nationality')" style="color: #eb1c1c">
                      Champ requis
                    </div>
                  </div>
                </div>

                <div class="relative z-0 w-full mb-0 md:mb-5 group">
                  <div class="flex items-center">
                    <input formControlName="nationality" id="bordered-radio-2" type="radio" value="Sénégal"
                      name="nationality"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('nationality') ? '2px solid #eb1c1c' : ''
                      " />
                    <label for="bordered-radio-2"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Sénégalaise</label>
                  </div>
                </div>
                <div class="relative z-0 w-full mb-5 group">
                  <div class="flex items-center">
                    <input formControlName="nationality" checked id="bordered-radio-2" type="radio" value="Autre"
                      name="nationality"
                      class="w-6 h-6 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      [style.border]="
                        isFieldInvalid('nationality') ? '2px solid #eb1c1c' : ''
                      " />
                    <label for="bordered-radio-2"
                      class="w-full py-4 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Autre</label>
                  </div>
                </div>
              </div>
              <!-- if other coutry -->

              <div class="grid md:grid-cols-3 md:gap-6 my-6 m-0" *ngIf="
                  soumissionForm.get('nationality')?.value != 'Sénégal' &&
                  (soumissionForm.get('nationality')?.value != null ||
                    soumissionForm.get('nationality')?.value != undefined)
                ">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Précisez votre nationalité
                      <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('otherCountry')" style="color: #eb1c1c">
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select type="text" id="otherCountry"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      formControlName="otherCountry" [style.border]="
                        isFieldInvalid('otherCountry')
                          ? '2px solid #eb1c1c'
                          : ''
                      ">
                      <option *ngFor="let country of countries" [value]="country.name">
                        {{ country.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="grid md:grid-cols-3 m-0 gap-6 my-6">
                <div class="relative z-0 w-full mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Région de résidence
                      <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('city')" style="color: #eb1c1c">
                      Champ requis !
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select formControlName="city" id="cities"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('city') ? '2px solid #eb1c1c' : ''
                      ">
                      <option *ngFor="let region of regions" [ngValue]="region">
                        {{ region.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="flex justify-between gap-2 gap-6 my-6">
                <span class="font-bold text-2xl">II. ORGANISATION</span>
              </div>
              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <!--*ngIf="showDegreeDiv"-->
              <div class="grid md:grid-cols-3 md:gap-6 my-6 m-0">
                <div class="relative z-0 w-full mb-0 md:mb-5 group">
                  <div class="col-span-1 label">
                    <div class="lg:me-3">
                      Représentant <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('roles')" style="color: #eb1c1c">
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full mb-5 group">
                    <select formControlName="roles" id="countries"
                      class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      [style.border]="
                        isFieldInvalid('roles') ? '2px solid #eb1c1c' : ''
                      ">
                      <option *ngFor="let item of listrole" [value]="item.id">
                        {{ item.value }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 md:gap-6 mt-5 md:mb-2 m-0">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Nom de l'organisation
                      <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('organizationName')" style="color: #eb1c1c">
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full group">
                    <input type="text"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      formControlName="organizationName" [style.border]="
                        isFieldInvalid('organizationName')
                          ? '2px solid #eb1c1c'
                          : ''
                      " />
                  </div>
                </div>
              </div>

              <div class="grid md:grid-cols-3 md:gap-6 mt-5 md:mb-2 m-0">
                <div class="relative z-0 w-full group">
                  <div class="col-span-1 label">
                    <div class="lg:flex lg:me-3">
                      Secteur d'expertise
                      <span style="color: red">*</span>
                    </div>
                    <div *ngIf="isFieldInvalid('expertiseSectorName')" style="color: #eb1c1c">
                      Champ requis
                    </div>
                  </div>
                </div>
                <div class="col-span-2 label">
                  <div class="relative z-0 w-full group">
                    <input type="text"
                      class="block w-full h-12 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-800 sm:text-sm sm:leading-6"
                      formControlName="expertiseSectorName" [style.border]="
                        isFieldInvalid('expertiseSectorName')
                          ? '2px solid #eb1c1c'
                          : ''
                      " />
                  </div>
                </div>
              </div>

              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />

              <div class="mt-6 sm:mx-auto sm:w-full lg:w-full">
                <div class="text-justify flex text-sm gap-2 align-items:start">
                  <div>
                    <input type="checkbox" id="conditions" class="h-5 w-5 mb-3 mr-3 mt-1 rounded"
                      formControlName="conditions" value="Accepté" name="conditions" [style.border]="
                        isFieldInvalid('conditions') ? '2px solid #eb1c1c' : ''
                      " />
                  </div>
                  <div class="text-xs md:text-sm">
                    J'autorise FORCE-N à conserver et à utiliser mes données
                    dans le cadre du programme. Les correspondances et l'accès
                    aux plateformes de formation seront générés à partir des
                    informations personnelles soumises ci-dessous. Veuillez donc
                    fournir des informations correctes et appropriées
                    <span style="color: red">*</span>
                  </div>
                </div>
              </div>

              <hr class="h-px my-8 bg-gray-300 border-0 dark:bg-gray-700" />
            </div>
            <div>
              <app-spinner *ngIf="showSpinner"></app-spinner>
            </div>
            <div class="flex justify-center items-center">
              <button [disabled]="showSpinner" type="submit"
                class="rounded-md w-48 h-12 px-3 py-2 text-sm font-semibold leading-6 text-white shadow-sm btn-login"
                (click)="onSubmitForm()">
                Soumission
              </button>
            </div>
          </form>
        </div>
      </app-card-form>
    </div>
  </div>
</div>

<!-- Pop-up d'alerte -->
<div *ngIf="showPopup" class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
  <div class="bg-white p-6 rounded-lg shadow-lg text-center">
    <h2 class="text-lg font-semibold text-red-600">Attention</h2>
    <p class="mt-2">
      Veuillez remplir tous les champs requis avant de soumettre.
    </p>
    <button (click)="showPopup = false" class="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md">
      OK
    </button>
  </div>
</div>



<div *ngIf="isLoading" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    
  <div class="bg-white p-6 rounded-lg shadow-lg flex flex-col items-center gap-4">
        <svg class="animate-spin h-10 w-10 text-orange-500" viewBox="0 0 24 24">
            
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
          
    </svg>

        <span class="text-gray-700 font-semibold">
            Soumission en cours...     </span>

      
  </div>
</div>

<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm transition-opacity"
  *ngIf="showMessage">
  <div class="relative w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-8 shadow-2xl transition-all">

    <div class="flex flex-col items-center text-center">

      <div class="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-blue-50">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 text-blue-500" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      <h2 class="mb-2 text-2xl font-bold text-gray-900">
        Informations
      </h2>

      <p class="mb-8 text-gray-500">
        {{message}}
      </p>

      <div class="w-full flex justify-center">
        <button type="button" (click)="togglePopup()"
          class="inline-flex w-full justify-center rounded-xl bg-gray-900 px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-gray-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-900 transition-all active:scale-95">
          Compris, fermer
        </button>
      </div>
    </div>

  </div>
</div>